// components/markdown/Highlight.tsx
import React from 'react';
import { twMerge } from 'tailwind-merge';
import type { BaseCustomProps } from './types';

// Helper function (can be moved to a utils file)
const getContrastYIQ = (hexcolor: string): string => {
  hexcolor = hexcolor.replace("#", "");
  // Basic error handling for invalid hex codes (optional but recommended)
  if (hexcolor.length !== 6) {
      console.warn(`Invalid hex color passed to getContrastYIQ: #${hexcolor}. Defaulting text to black.`);
      return '#000'; // Default to black on error
  }
  try {
      const r = parseInt(hexcolor.substring(0, 2), 16);
      const g = parseInt(hexcolor.substring(2, 4), 16);
      const b = parseInt(hexcolor.substring(4, 6), 16);
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return (yiq >= 128) ? '#000' : '#fff';
  } catch (e) {
      console.error(`Error parsing hex color #${hexcolor}`, e);
      return '#000'; // Default to black on error
  }
};


export const Highlight: React.FC<BaseCustomProps> = ({
  children,
  color = '#ffeb3b', // Default background is still yellow
  className
}) => {
  // Determine the text color dynamically based on the background color
  const textColor = getContrastYIQ(color);

  return (
    <span
      className={twMerge('rounded px-1 py-0.5 font-medium', className)}
      style={{
        backgroundColor: color,
        color: textColor, // Use the dynamically calculated text color
      }}
    >
      {children}
    </span>
  );
};